<template>
  <v-flex>
<!--    <v-subheader>预测短信-->
<!--      <v-btn :loading="predictLoading" small flat color="primary" @click="predictMessage()">刷新</v-btn>-->
<!--    </v-subheader>-->
<!--    <v-layout>-->
<!--      <v-flex>-->
<!--        <p class="subheading px-2">{{'未搜索到模板'}}</p>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
    <v-subheader>最终确认</v-subheader>
    <v-layout wrap>
      <v-flex xs12 layout align-center>
        <v-flex>
          <select-violation-rule
            :disabled="!event.isEditRule"
            v-model="event.results[VIOLATION_ROLE.VIOLATION_ADMIN].type"
            hint="若违章类型不符合取证，可以修改"
            persistent-hint
          ></select-violation-rule>
        </v-flex>
        <v-btn class="mr-0" v-if="!event.isEditRule" @click="onEditRule(true)" color="primary" small flat>修改</v-btn>
      </v-flex>
      <v-flex xs12 v-if="event.isEditRule">
        <v-btn color="primary" small flat @click="onEditRule(false)">确定</v-btn>
        <v-btn color="grey" small flat @click="revertRule">取消</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          label="违章管理员附言"
          prepend-icon="$vuetify.icons.comment"
          auto-grow
          :rows="1"
          v-model="event.results[VIOLATION_ROLE.VIOLATION_ADMIN].comment"></v-textarea>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import {VIOLATION_ROLE} from '../../../object'
import SelectViolationRule from '../../../components/selectViolationRule'

export default {
  name: 'finalPredictForm',
  components: {SelectViolationRule},
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    VIOLATION_ROLE,
    predictLoading: false,
  }),
  methods: {
    async predictMessage () {
      try {
        this.predictLoading = true
        let res = await this.$store.dispatch('violation/predictMessage', this.event)
        console.log(res)
      }
      catch (e) {
        console.error(e)
      }
      finally {
        this.predictLoading = false
      }
    },
    onEditRule (val) {
      this.$set(this.event, 'isEditRule', val)
      this.predictMessage()
    },
    assignRule () {
      // 只赋值一次
      if (!this.event.results[VIOLATION_ROLE.VIOLATION_ADMIN].type) {
        this.event.results[VIOLATION_ROLE.VIOLATION_ADMIN].type = this.event.type
      }
    },
    revertRule () {
      this.event.results[VIOLATION_ROLE.VIOLATION_ADMIN].type = this.event.results[VIOLATION_ROLE.ALARM_ADMIN].type
      this.event.isEditRule = false
    }
  },
  created () {
    this.assignRule()
    this.predictMessage()
  },
  activated () {
    this.assignRule()
    this.predictMessage()
  }
}
</script>

<style scoped>

</style>
